module.exports = __webpack_public_path__ + "img/footer-shape-1.7248f5eb.png";